// import React, { useEffect, useState } from "react";

// const LoaderRedirect = () => {
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const urlParams = new URLSearchParams(window.location.search);
//     const tranid = urlParams.get("tranid");
//     const returnUrl = decodeURIComponent(urlParams.get("returnUrl") || "");
//     const type = urlParams.get("type");
//     let url;

//     if (!tranid) {
//       setError("Missing 'tranid' in URL");
//       return;
//     }

//     // if (type === "2") {
//     //   url = `https://devapi.saloracapital.com/api/oneMoney/json?consentHandle=${tranid}`; //live url;
//     if (type === "2") {
//   url = `https://devapi.saloracapital.com/api/oneMoney/fallback?consentHandle=${tranid}&returnUrl=${encodeURIComponent(returnUrl)}`;

//     } else {
//       url = `https://devapi.saloracapital.com/api/aadhaar/step?tranid=${tranid}`;//live url;
//     }

//     fetch(url)
//       .then((res) => {
//         if (!res.ok) {
//           throw new Error("API failed: " + res.status);
//         }
//         return res.text();
//       })
//       .then(() => {
//         if (returnUrl) {
//           setTimeout(() => {
//             window.location.href = returnUrl;
//           }, 100);
//         }
//       })
//       .catch((err) => {
//         setError(err.message);
//       });
//   }, []);

//   return (
//     <div style={styles.container}>
//       {error ? (
//         <pre style={styles.error}>Error: {error}</pre>
//       ) : (
//         <div style={styles.loader}></div>
//       )}
//     </div>
//   );
// };

// const styles = {
//   container: {
//     height: "100vh",
//     width: "100%",
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//     fontFamily: "Arial, sans-serif",
//     textAlign: "center",
//   },
//   loader: {
//     border: "8px solid #f3f3f3",
//     borderTop: "8px solid #3498db",
//     borderRadius: "50%",
//     width: "60px",
//     height: "60px",
//     animation: "spin 1s linear infinite",
//   },
//   error: {
//     padding: "10px",
//     color: "red",
//   },
// };

// // CSS animation
// const styleSheet = document.styleSheets[0];
// styleSheet.insertRule(`
// @keyframes spin {
//   0% { transform: rotate(0deg); }
//   100% { transform: rotate(360deg); }
// }
// `, styleSheet.cssRules.length);

// export default LoaderRedirect;


// // weebhook



import React, { useEffect, useState } from "react";

const API_LIST = [
  "https://lspjava.saloracapital.com", // primary
  "https://lspapi.saloracapital.com",  // fallback
];

const LoaderRedirect = () => {
  const [error, setError] = useState(null);

  useEffect(() => {
    // Inject CSS once
    const style = document.createElement("style");
    style.innerHTML = `
      .loader-container {
        height: 100vh;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: Arial, sans-serif;
        background: #ffffff;
      }

      .loader {
        border: 8px solid #f3f3f3;
        border-top: 8px solid #3498db;
        border-radius: 50%;
        width: 60px;
        height: 60px;
        animation: spin 1s linear infinite;
      }

      @keyframes spin {
        to {
          transform: rotate(360deg);
        }
      }

      .error-text {
        color: red;
        font-size: 14px;
        padding: 10px;
        background: #fff0f0;
        border: 1px solid #ffcccc;
        border-radius: 4px;
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const tranid = params.get("tranid");
    const type = params.get("type");
    const returnUrl = decodeURIComponent(params.get("returnUrl") || "");

    if (!tranid) {
      setError("Missing 'tranid' in URL");
      return;
    }

    const buildUrl = (baseUrl) =>
      type === "2"
        ? `${baseUrl}/api/oneMoney/json?consentHandle=${tranid}`
        : `${baseUrl}/api/aadhaar/step?tranid=${tranid}`;

    const callApiWithFallback = async () => {
      for (let baseUrl of API_LIST) {
        try {
          const res = await fetch(buildUrl(baseUrl));
          if (!res.ok) throw new Error(`API failed on ${baseUrl}`);

          await res.text(); // webhook-style call

          if (returnUrl) {
            setTimeout(() => {
              window.location.href = returnUrl;
            }, 100);
          }
          return; // success → stop
        } catch (err) {
          console.warn("API failed:", baseUrl);
        }
      }
      setError("All APIs failed. Please try again later.");
    };

    callApiWithFallback();
  }, []);

  return (
    <div className="loader-container">
      {error ? (
        <pre className="error-text">Error: {error}</pre>
      ) : (
        <div className="loader"></div>
      )}
    </div>
  );
};

export default LoaderRedirect;